<section
    id="reservieren"
    class="top-8 sticky shadow-md border border-neutral-400 rounded-2xl h-fit ~p-4/8"
>
    @if (bookingService.config.value()?.data?.bookingsPossible) {
        <h3 class="mb-4 text-2xl">
            {{ "booking.bookingFullForm.createNonBindingRequest" | translate }}
        </h3>
        <form
            [formGroup]="form"
            class="mx-auto max-w-[85rem]"
            (ngSubmit)="onSubmit()"
            (click)="scrollToForm()"
        >
            <div class="gap-4 grid">
                <!-- First Name -->
                <div class="flex sm:flex-row flex-col gap-4">
                    <div class="grow">
                        <label for="firstName" class="block mb-2 font-medium">
                            {{
                                "booking.bookingFullForm.firstName" | translate
                            }}*
                        </label>
                        <input
                            type="text"
                            name="firstName"
                            id="firstName"
                            class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                            formControlName="firstName"
                        />
                        <span
                            *ngIf="
                                form.get('firstName')?.hasError('required') &&
                                (form.get('firstName')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                            >{{
                                "booking.bookingFullForm.firstName" | translate
                            }}
                            {{
                                "booking.bookingFullForm.isRequired" | translate
                            }}</span
                        >
                        <span
                            *ngIf="
                                form.get('firstName')?.hasError('minlength') &&
                                (form.get('firstName')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{
                                "booking.bookingFullForm.firstName" | translate
                            }}
                            {{
                                "booking.bookingFullForm.isTooShort" | translate
                            }}</span
                        >
                        <span
                            *ngIf="
                                form.get('firstName')?.hasError('maxlength') &&
                                (form.get('firstName')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{
                                "booking.bookingFullForm.firstName" | translate
                            }}
                            {{
                                "booking.bookingFullForm.isTooLong" | translate
                            }}</span
                        >
                    </div>
                    <!-- Last Name -->
                    <div class="grow">
                        <label for="lastName" class="block mb-2 font-medium">
                            {{
                                "booking.bookingFullForm.lastName" | translate
                            }}*
                        </label>
                        <input
                            type="text"
                            name="lastName"
                            id="lastName"
                            class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                            formControlName="lastName"
                        />
                        <span
                            *ngIf="
                                form.get('lastName')?.hasError('required') &&
                                (form.get('lastName')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{ "booking.bookingFullForm.lastName" | translate }}
                            {{
                                "booking.bookingFullForm.isRequired" | translate
                            }}</span
                        >
                        <span
                            *ngIf="
                                form.get('lastName')?.hasError('minlength') &&
                                (form.get('lastName')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{ "booking.bookingFullForm.lastName" | translate }}
                            {{
                                "booking.bookingFullForm.isTooShort" | translate
                            }}</span
                        >
                        <span
                            *ngIf="
                                form.get('lastName')?.hasError('maxlength') &&
                                (form.get('lastName')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{ "booking.bookingFullForm.lastName" | translate }}
                            {{
                                "booking.bookingFullForm.isTooLong" | translate
                            }}</span
                        >
                    </div>
                </div>
                <div class="flex sm:flex-row flex-col gap-4">
                    <div class="sm:w-3/5">
                        <label for="street" class="block mb-2 font-medium">
                            {{ "booking.bookingFullForm.street" | translate }}*
                        </label>
                        <input
                            type="text"
                            name="street"
                            id="street"
                            class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                            formControlName="street"
                        />
                        <span
                            *ngIf="
                                form.get('street')?.hasError('required') &&
                                (form.get('street')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{ "booking.bookingFullForm.street" | translate }}
                            {{
                                "booking.bookingFullForm.isRequired" | translate
                            }}</span
                        >
                        <span
                            *ngIf="
                                form.get('street')?.hasError('maxlength') &&
                                (form.get('street')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{ "booking.bookingFullForm.street" | translate }}
                            {{
                                "booking.bookingFullForm.isTooLong" | translate
                            }}</span
                        >
                    </div>
                    <div class="grow">
                        <label for="houseNumber" class="block mb-2 font-medium">
                            {{
                                "booking.bookingFullForm.houseNumber"
                                    | translate
                            }}*
                        </label>
                        <input
                            type="text"
                            name="houseNumber"
                            id="houseNumber"
                            class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                            formControlName="houseNumber"
                        />
                        <span
                            *ngIf="
                                form.get('houseNumber')?.hasError('required') &&
                                (form.get('houseNumber')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{
                                "booking.bookingFullForm.houseNumber"
                                    | translate
                            }}
                            {{
                                "booking.bookingFullForm.isRequired" | translate
                            }}</span
                        >
                        <span
                            *ngIf="
                                form
                                    .get('houseNumber')
                                    ?.hasError('maxlength') &&
                                (form.get('houseNumber')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{
                                "booking.bookingFullForm.houseNumber"
                                    | translate
                            }}
                            {{
                                "booking.bookingFullForm.isTooLong" | translate
                            }}</span
                        >
                    </div>
                </div>

                <div class="flex sm:flex-row flex-col gap-4">
                    <div class="sm:w-2/5">
                        <label for="postalCode" class="block mb-2 font-medium">
                            {{
                                "booking.bookingFullForm.postalCode"
                                    | translate
                            }}*
                        </label>
                        <input
                            type="text"
                            name="postalCode"
                            id="postalCode"
                            class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                            formControlName="postalCode"
                        />
                        <span
                            *ngIf="
                                form.get('postalCode')?.hasError('required') &&
                                (form.get('postalCode')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{
                                "booking.bookingFullForm.postalCode" | translate
                            }}
                            {{
                                "booking.bookingFullForm.isRequired" | translate
                            }}</span
                        >
                        <span
                            *ngIf="
                                form.get('postalCode')?.hasError('maxlength') &&
                                (form.get('postalCode')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{
                                "booking.bookingFullForm.postalCode" | translate
                            }}
                            {{
                                "booking.bookingFullForm.isTooLong" | translate
                            }}</span
                        >
                    </div>
                    <div class="grow">
                        <label for="place" class="block mb-2 font-medium">
                            {{ "booking.bookingFullForm.place" | translate }}*
                        </label>
                        <input
                            type="text"
                            name="place"
                            id="place"
                            class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                            formControlName="place"
                        />
                        <span
                            *ngIf="
                                form.get('place')?.hasError('required') &&
                                (form.get('place')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{ "booking.bookingFullForm.place" | translate }}
                            {{
                                "booking.bookingFullForm.isRequired" | translate
                            }}</span
                        >
                        <span
                            *ngIf="
                                form.get('place')?.hasError('maxlength') &&
                                (form.get('place')?.touched ||
                                    bookingService.formState() ===
                                        formStateEnum.Invalid)
                            "
                            class="text-red-500 text-sm"
                        >
                            {{ "booking.bookingFullForm.place" | translate }}
                            {{
                                "booking.bookingFullForm.isTooLong" | translate
                            }}</span
                        >
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label for="email" class="block mb-2 font-medium">
                        E-Mail*
                    </label>
                    <input
                        type="email"
                        name="email"
                        id="email"
                        class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                        formControlName="email"
                    />
                    <span
                        *ngIf="
                            form.get('email')?.hasError('required') &&
                            (form.get('email')?.touched ||
                                bookingService.formState() ===
                                    formStateEnum.Invalid)
                        "
                        class="text-red-500 text-sm"
                    >
                        E-Mail
                        {{
                            "booking.bookingFullForm.isRequired" | translate
                        }}</span
                    >
                    <span
                        *ngIf="
                            form.get('email')?.hasError('email') &&
                            (form.get('email')?.touched ||
                                bookingService.formState() ===
                                    formStateEnum.Invalid)
                        "
                        class="text-red-500 text-sm"
                    >
                        E-Mail
                        {{
                            "booking.bookingFullForm.isInvalid" | translate
                        }}</span
                    >
                </div>

                <!-- Phone -->
                <div>
                    <label for="phone" class="block mb-2 font-medium">
                        {{ "booking.bookingFullForm.phoneNumber" | translate }}*
                    </label>
                    <input
                        type="tel"
                        name="phone"
                        id="phone"
                        class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                        formControlName="phone"
                    />
                    <span
                        *ngIf="
                            form.get('phone')?.hasError('required') &&
                            (form.get('phone')?.touched ||
                                bookingService.formState() ===
                                    formStateEnum.Invalid)
                        "
                        class="text-red-500 text-sm"
                    >
                        {{ "booking.bookingFullForm.phoneNumber" | translate }}
                        {{
                            "booking.bookingFullForm.isRequired" | translate
                        }}</span
                    >
                    <span
                        *ngIf="
                            form.get('phone')?.hasError('minlength') &&
                            (form.get('phone')?.touched ||
                                bookingService.formState() ===
                                    formStateEnum.Invalid)
                        "
                        class="text-red-500 text-sm"
                    >
                        {{ "booking.bookingFullForm.phoneNumber" | translate }}
                        {{
                            "booking.bookingFullForm.isTooShort" | translate
                        }}</span
                    >
                    <span
                        *ngIf="
                            form.get('phone')?.hasError('maxlength') &&
                            (form.get('phone')?.touched ||
                                bookingService.formState() ===
                                    formStateEnum.Invalid)
                        "
                        class="text-red-500 text-sm"
                    >
                        {{ "booking.bookingFullForm.phoneNumber" | translate }}
                        {{
                            "booking.bookingFullForm.isTooLong" | translate
                        }}</span
                    >
                </div>

                <!-- Message -->
                <div>
                    <label for="message" class="block mb-2 font-medium">
                        {{ "booking.bookingFullForm.message" | translate }}
                    </label>
                    <textarea
                        id="message"
                        name="message"
                        placeholder="{{
                            'contactApartment.contactForm.writeMessage'
                                | translate
                        }}"
                        rows="4"
                        formControlName="message"
                        class="block disabled:opacity-50 px-4 py-3 border-gray-200 focus:border-blue-500 rounded-lg focus:ring-blue-500 w-full text-sm disabled:pointer-events-none"
                    ></textarea>
                    <span
                        *ngIf="
                            form.get('message')?.hasError('minlength') &&
                            (form.get('message')?.touched ||
                                bookingService.formState() ===
                                    formStateEnum.Invalid)
                        "
                        class="text-red-500 text-sm"
                    >
                        {{ "booking.bookingFullForm.message" | translate }}
                        {{
                            "booking.bookingFullForm.isTooShort" | translate
                        }}</span
                    >
                    <span
                        *ngIf="
                            form.get('message')?.hasError('maxlength') &&
                            (form.get('message')?.touched ||
                                bookingService.formState() ===
                                    formStateEnum.Invalid)
                        "
                        class="text-red-500 text-sm"
                    >
                        {{ "booking.bookingFullForm.message" | translate }}
                        {{
                            "booking.bookingFullForm.isTooLong" | translate
                        }}</span
                    >
                </div>
                <div>
                    <div class="flex">
                        <input
                            type="checkbox"
                            id="privacyPolicy"
                            class="disabled:opacity-50 mt-0.5 border-gray-200 rounded focus:ring-blue-500 text-blue-600 disabled:pointer-events-none shrink-0"
                            formControlName="privacyPolicy"
                        />
                        <label
                            for="privacyPolicy"
                            class="ms-3 text-gray-500 text-sm"
                        >
                            {{ "booking.bookingFullForm.agreeTo" | translate }}
                            <a [routerLink]="['datenschutz']" class="underline">
                                {{
                                    "booking.bookingFullForm.privacyPolicy"
                                        | translate
                                }}
                            </a>
                        </label>
                    </div>
                    <span
                        *ngIf="
                            form.get('privacyPolicy')?.hasError('required') &&
                            (form.get('privacyPolicy')?.touched ||
                                bookingService.formState() ===
                                    formStateEnum.Invalid)
                        "
                        class="text-red-500 text-sm"
                    >
                        {{
                            "booking.bookingFullForm.privacyPolicy" | translate
                        }}
                        {{
                            "booking.bookingFullForm.isRequired" | translate
                        }}</span
                    >
                </div>
            </div>

            <!-- Submit Button -->
            @if (
                bookingService.formState() ===
                    bookingService.formStateEnum.Idle ||
                bookingService.formState() ===
                    bookingService.formStateEnum.Invalid
            ) {
                <app-button class="block mt-6" type="submit">
                    {{ "booking.bookingFullForm.submitRequest" | translate }}
                </app-button>
            }
            @if (
                bookingService.formState() ===
                bookingService.formStateEnum.Submitting
            ) {
                <div
                    class="inline-block mx-auto mt-3 border-4 border-current border-t-transparent rounded-full size-8 text-primary animate-spin"
                    role="status"
                    aria-label="loading"
                >
                    <span class="sr-only">Loading...</span>
                </div>
            }
        </form>
    } @else {
        <p class="text-red-500 text-lg">
            {{ "booking.bookingForm.bookingsNotPossible" | translate }}
        </p>
    }
</section>
